// src/pages/Appli/AppliAdmin/users-admin/components/SendMessageModal.jsx

import React from "react";

import { FaEnvelope } from "react-icons/fa";

import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "../../../../../components/Modal/Modal";

export default function SendMessageModal({
  modal,
}) {
  return (
    <Modal
      isOpen={modal.isOpen}
      onClose={modal.close}
      size="md"
      labelledById="send-user-message-title"
      describedById="send-user-message-description"
      initialFocusSelector="#send-user-message-subject"
    >
      <ModalHeader
        id="send-user-message-title"
        title="Envoyer un message"
        subtitle={
          modal.targetUser
            ? `Destinataire : ${modal.targetUser.prenom || ""} ${
                modal.targetUser.nom || ""
              }`
            : "Messagerie utilisateur"
        }
        onClose={modal.close}
      />

      <ModalBody id="send-user-message-description">
        <form
          onSubmit={modal.submit}
          className="space-y-4"
        >
          <div>
            <label
              htmlFor="send-user-message-subject"
              className="text-sm font-medium text-slate-700 dark:text-slate-200"
            >
              Sujet
            </label>

            <input
              id="send-user-message-subject"
              type="text"
              value={modal.subject}
              onChange={(event) =>
                modal.setSubject(event.target.value)
              }
              required
              data-autofocus
              autoComplete="off"
              className="mt-1 w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-slate-900 dark:border-slate-700 dark:bg-slate-900 dark:text-white"
              placeholder="Sujet du message"
            />
          </div>

          <div>
            <label
              htmlFor="send-user-message-content"
              className="text-sm font-medium text-slate-700 dark:text-slate-200"
            >
              Message
            </label>

            <textarea
              id="send-user-message-content"
              value={modal.content}
              onChange={(event) =>
                modal.setContent(event.target.value)
              }
              required
              rows={6}
              className="mt-1 w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-slate-900 dark:border-slate-700 dark:bg-slate-900 dark:text-white"
              placeholder="Votre message…"
            />
          </div>

          <ModalFooter>
            <button
              type="button"
              onClick={modal.close}
              className="inline-flex h-10 items-center rounded-2xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
            >
              Annuler
            </button>

            <button
              type="submit"
              disabled={modal.sending}
              className="inline-flex h-10 items-center gap-2 rounded-2xl bg-emerald-600 px-4 text-sm font-semibold text-white disabled:opacity-50"
            >
              <FaEnvelope />

              {modal.sending ? "Envoi…" : "Envoyer"}
            </button>
          </ModalFooter>
        </form>
      </ModalBody>
    </Modal>
  );
}